import Icon from './Icon';

const Lock = (props) => (
  <Icon
    {...props}
    path="M61.667 27.233h-5.567v-3.333c0-8.892-7.208-16.1-16.1-16.1s-16.1 7.208-16.1 16.1v0 3.333h-5.567c-1.373 0.019-2.481 1.127-2.5 2.498v36.668c0 1.381 1.119 2.5 2.5 2.5v0h43.333c1.381 0 2.5-1.119 2.5-2.5v0-36.667c-0.019-1.373-1.127-2.481-2.498-2.5h-0.002zM28.9 23.9c0-6.13 4.97-11.1 11.1-11.1s11.1 4.97 11.1 11.1v0 3.333h-22.2zM40 54.7c-3.222 0-5.833-2.612-5.833-5.833s2.612-5.833 5.833-5.833c3.222 0 5.833 2.612 5.833 5.833v0c0 3.222-2.612 5.833-5.833 5.833v0z"
  />
);

export default Lock;
